export enum ViolationSeverity {
	none = 'none',
	soft = 'soft',
	hard = 'hard',
}

export const ChangeLicenseState = 'Front.License.ChangeLicenseState';
export interface ChangeLicenseState {
	type: typeof ChangeLicenseState;
	severity: ViolationSeverity;
}
